export const ROUTES = {
    // Públicas
    home: "/",
    signup: "/signup",
    login: "/login",
    forgotPassword: "/esqueci-senha",
    resetPassword: "/redefinir-senha",
    terms: "/termos",
    privacy: "/privacidade",

    // Usuário autenticado
    dashboard: "/dashboard",
    schedule: "/planejamento",
    training: "/treinos",
    calendar: "/agenda",
    ranking: "/ranking",
    account: "/conta",
    feedbacks: "/feedbacks",
    evaluationDetail: (id = ":evaluationId") => `/avaliacao/${id}`,
    evaluationHistoric: "/avaliacoes",
  
    // Rotas restritas a admin
    adminHome: "/admin",
    adminClients: "/admin/alunas",
    adminLibrary: "/admin/biblioteca",
    adminAnnouncements: "/admin/avisos",
    adminCreateEvaluation: "/admin/criar-avaliacao",
    adminEditUser: (userId = ":userId") => `/admin/users/${userId}`,
    adminUserSchedule: (userId = ":userId") => `/admin/planejamento/${userId}`,
    adminUserEvaluations: (userId = ":userId") => `/admin/avaliacoes/${userId}`,
    adminFeedbacks: "/admin/feedbacks",
    
    // Rota fallback
    fallback: "*"
  };
  